import ct from 'countries-and-timezones'
import React from 'react'
import Select from 'react-select'
import { selectThemeColors } from '@utils'

const TimeZoneSelect = ({ onChange }) => {
  const tz = ct.getAllTimezones()
  const timezones = new Array()

  for (const [area, data] of Object.entries(tz)) {
    timezones.push({value: `UTC${data.utcOffsetStr} - ${area}`, label: `UTC${data.utcOffsetStr} - ${area}`})
  }

  return (
    <Select
      isClearable={false}
      theme={selectThemeColors}
      id={`timezone`}
      options={timezones}
      className='react-select'
      classNamePrefix='select'
      onChange={onChange}
    />
  )
}

export default TimeZoneSelect